import { useStore } from "../store";

export const useBaseMediaUrls = (type) => {
  const { baseMediaUrls } = useStore();
  switch (type) {
    case "images":
      return baseMediaUrls?.image;
    case "videos":
      return baseMediaUrls?.video;
    default:
      return "";
  }
};
